import { map, finalize, catchError } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { DataService } from '../../../core/service/base/data.service';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { HttpClient } from '@angular/common/http';
import { PrintOrder } from '../../model/print-order';
import { Observable } from 'rxjs';

@Injectable()
export class PrintOrderService extends DataService<PrintOrder> {
  private readonly _defaultFilterFields: string[] = ['caption'];

  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, PrintOrder, progressBar, 'printorder');
  }

  download(model: PrintOrder): Observable<File> {
    this.progressBar.start();
    return this.getFile(`${this.endpoint}/download/${model.id}`, 'document').pipe(
      catchError(error => {
        this.notification.showError(error);
        return [];
      }),
      finalize(() => this.progressBar.stop())
    );
  }

  getFilterDefinition(): Observable<{
    caption: string;
    selectedFields: string[];
    defaultFields: string[];
  }> {
    return this.client.get<any>(`${this.endpoint}/filter`).pipe(
      map(res => {
        return {
          caption: res.caption ? res.caption : '',
          selectedFields: Array.isArray(res.selectedFields) ? res.selectedFields : this._defaultFilterFields,
          defaultFields: this._defaultFilterFields,
        };
      }),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }
}
